module.exports = __webpack_public_path__ + "static/img/asdfs.05a579c7.png";